import sportsApi from '../../utils/sportsApi';

export const updateRightsholderTextTrackingFilter = (
    clientId,
    rhTextTrackingFilterId,
    shouldActivate,
) => {
    return sportsApi
        .url(`/clients/${clientId}/text-tracking-filters`)
        .json({
            association: shouldActivate ? 'add' : 'remove',
            entityIds: [rhTextTrackingFilterId],
        })
        .put();
};
